export const ExpenseOptionIcon = ({ ...rest }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="48" height="48" rx="8" fill="#FFEEE9" />
      <path
        d="M20 18H28H20ZM20 22H28H20ZM20 26H23H20ZM18 34H30C31.1046 34 32 33.1046 32 32V16C32 14.8954 31.1046 14 30 14H18C16.8954 14 16 14.8954 16 16V32C16 33.1046 16.8954 34 18 34Z"
        fill="white"
        stroke="#FD561F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
